@if (statusMessage) {
  @if (context === 'banner') {
    <div class="full-warning-banner">
      <ng-container *ngTemplateOutlet="warnBanner"/>
    </div>
  }
  @if (context === 'placeHold') {
    <ng-container *ngTemplateOutlet="warnBanner"/>
  }

  <ng-template #warnBanner>
    <div class="warn-banner-body">
      <div class="warn-banner-title">{{ statusTitle }}</div>
      <span>{{ statusMessage }} </span>
      @if (statusActionLink) {
        <a class="pointer" (click)="statusActionLink()">{{ statusActionLabel }}</a>
      }
    </div>
  </ng-template>

  @if (context === 'dropdown') {
    <div class="warn-dropdown-wrapper">
      <button mat-button [matMenuTriggerFor]="statusAlertMenu" class="warn-dropdown">
        <mat-icon color="warn">error</mat-icon>
      </button>
      <mat-menu #statusAlertMenu="matMenu" [overlapTrigger]="false" class="remove-max-width remove-padding">
        <div class="alert-wrapper">
          <div class="alert-menu-header flex-row flex-center-start">
            <span class="header-icon-container">
              <mat-icon>error_outline</mat-icon>
            </span>
            <h4 class="header-title">Alerts</h4>
          </div>
          <h4 class="title-row flex-row flex-center-start">
            <span class="message-icon-container">
              <mat-icon color="warn">error</mat-icon>
            </span>
            <span class="title">{{ statusTitle }}</span>
          </h4>
          <div class="message-text">
            {{ statusMessage }}
            @if (statusActionLink) {
              <a class="pointer" (click)="statusActionLink()">{{ statusActionLabel }}</a>
            }
          </div>
        </div>
      </mat-menu>
    </div>
  }
}
